import React from 'react';
import type { Settings } from 'react-slick';
import { Box } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { PHOTO_PRESENTATION_CONFIG } from '@shared/utils/photoPresentationLayout';

export const CONTAINER_ASPECT_RATIO = PHOTO_PRESENTATION_CONFIG.photoSlider.brannan?.aspectRatio as number;

export const SLIDER_BASE_SETTINGS: Settings = {
  dots: true,
  infinite: true,
  waitForAnimate: false,
  speed: 2500,
  slidesToShow: 1,
  slidesToScroll: 1,
  fade: true,
  autoplay: true,
  autoplaySpeed: 6000,
  cssEase: 'ease',
  pauseOnHover: false,
  customPaging: () => (
    <Box
      className="custom-dot"
      width={{ _: pxToRem(20), xs: 8, sm2: pxToRem(46) }}
      height={1}
      borderRadius="full"
      backgroundColor="white"
    />
  ),
};
